import React, { Component } from "react";
import { GetStartedImages } from "./GetStartedImages";
import StartEarningRewards from '../buttons/StartEarningRewards';
import EnrollingComponent from '../enrolling-component/enrolling-component';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './get-started.css'

var Scroll   = require('react-scroll');
var Element  = Scroll.Element;

var settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: true,
            autoplaySpeed:2000
};

class GetStarted extends Component{
  
  constructor(props){
    super(props);
    this.state={
      ViewVisible:false,
    }
  }


  componentDidMount(){
    window.addEventListener("resize",this.getSliderView);
    this.getSliderView();
  }

  getSliderView=()=>{
    if(window.innerWidth<=767){
      this.setState({ViewVisible:true});
    }else if(window.innerWidth>767){
      this.setState({ViewVisible:false});
    }
  }

  getDesktopView=()=>{
    return(
    <Element name="get-started">
      <ul className="get-started-list" >
          <li>
              <div className="step-img">
                <img src={GetStartedImages.complete_webtalk_account.url} alt={""}/>
                <span>1</span>
              </div>
              <h3>Complete Webtalk Account</h3>
              <p>
                Create a FREE Webtalk account today. Then complete your profile to 100% using the provided completeness meter.
              </p>
            </li>
            <li>
              <div className="step-img">
                <img src={GetStartedImages.link_a_payment_account.url} alt={""}/>
                <span>2</span>
              </div>
              <h3>Link a payment account</h3>
              <p>
                Connect your PayPal, Payoneer, or Stripe accounts with Webtalk so you can easily cash in your rewards.
              </p>
            </li>
            <li>
              <div className="step-img">
                <img src={GetStartedImages.login_daily_and_be_social.url} alt={""}/>
                <span>3</span>
              </div>
              <h3>Login daily and be social</h3>
              <p>
                Share your personal and professional content to your target audiences to get engagement and to build your following.
              </p>
            </li>
      </ul>
    </Element>
      )
  }

  getMobileView=()=>{
    return(
        <Slider {...settings}>
           <div>
              <div className="step-img">
                <img src={GetStartedImages.complete_webtalk_account.url} alt={""}/>
                <span>1</span>
              </div>
              <h3>Complete Webtalk Account</h3>
              <p>
                Create a FREE Webtalk account today. Then complete your profile to 100% using the provided completeness meter.
              </p>
            </div>
            <div>
              <div className="step-img">
                <img src={GetStartedImages.link_a_payment_account.url} alt={""}/>
                <span>2</span>
              </div>
              <h3>Link a payment account</h3>
              <p>
                Connect your PayPal, Payoneer, or Stripe accounts with Webtalk so you can easily cash in your rewards.
              </p>
            </div>
            <div>
              <div className="step-img">
                <img src={GetStartedImages.login_daily_and_be_social.url} alt={""}/>
                <span>3</span>
              </div>
              <h3>Login daily and be social</h3>
              <p>
                Share your personal and professional content to your target audiences to get engagement, and to build your following
              </p>
            </div>
          </Slider>
      )
  }

  render(){
    return(
      <section className="get-started">
        <div className="container animate-fade">
          
          <h2>get started</h2>
          <p>There's only 3 steps to get started with Webtalk Rewards</p>
          {this.state.ViewVisible ? this.getMobileView() : this.getDesktopView()}
          <StartEarningRewards/>
          <EnrollingComponent/>
        </div>
      </section>
  

      )

  }
}

export default GetStarted;


